import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from "reactstrap"
import { Link } from "react-router-dom"

//import action
import { getChartsData as onGetChartsData } from "../../store/actions"

// Pages Components
import WelcomeComp from "./WelcomeComp"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import CenterCapacity from "./CenterCapacity"
import ParticipantsMeasure from "./ParticipantsMeasure"
import Summary from "./Summary"
import { useRole } from "hooks/useRole"
import TrainingSummary from "./TrainingSummary"
import HouseholdSummary from "./HouseholdSummary"

const Dashboard = props => {
  const dispatch = useDispatch()
  const { isAdmin, isVendor } = useRole()

  //////////////////BASIC SETTING STATE/////////////////////
  const { basicSetting } = useSelector(state => state.Layout)
  //////////////////////////////////////

  useEffect(() => {
    dispatch(onGetChartsData())
  }, [dispatch])

  //meta title
  document.title =
    "Dashboard | " + (basicSetting?.SiteName || process.env.REACT_APP_NAME)
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t("Home")}
            breadcrumbItem={props.t("Dashboard")}
          />
          <>
            <Row>
              <Col xl="4">
                <WelcomeComp />
              </Col>
              <Col xl="8">
                <Summary />
              </Col>
            </Row>
            <Row>
              <Col xl="6">{isAdmin && <HouseholdSummary />}</Col>
              <Col xl="6">{isAdmin && <TrainingSummary />}</Col>
            </Row>
          </>
        </Container>
      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Dashboard)
